import PropTypes from 'prop-types';
import React from 'react';
import Avatar from 'react-avatar';
import Griddle, { plugins, RowDefinition, ColumnDefinition } from 'griddle-react';
import {
  ButtonToolbar,
  Button,

} from 'react-bootstrap';
import StyledGriddle from '../../../components/StyledGriddle';

const AvatarColumn = ({ value }) => <Avatar name={value} size={32} src={value} round />;
class TourRosterTable extends React.Component {
  constructor(props) {
    super(props);
    const toolbar = ({ value }) => (
      <ButtonToolbar>
        <Button
          name="Edit"
          bsStyle="success"
          data-item={value}
          title="Edit User"
          onClick={this.props.handleEditMember}
        >
          <i className="fa fa-pencil fa-lg" />
        </Button>
        {!this.props.readOnly && (
          <Button
            name="Remove"
            bsStyle="danger"
            title="Remove from Tour"
            data-item={value}
            onClick={this.props.handleRemoveMember}
          >
            <i className="fa fa-trash-o fa-lg" />
          </Button>
        )}
      </ButtonToolbar>);

    this.state = {
      toolbar,
    };
  }
  render() {
    const roster = [];
    this.props.members.forEach((member) => {
      const photo = member.photo ? member.photo : `${member.first_name} ${member.last_name}`;
      roster.push({
        id: member.id,
        first_name: member.first_name,
        last_name: member.last_name,
        title: member.title,
        email: member.email,
        group: member.group.name,
        image: photo,
      });
    });

    return (
      <StyledGriddle
        data={roster}
      >
        <RowDefinition>
          <ColumnDefinition id="image" title=" " customComponent={AvatarColumn} />
          <ColumnDefinition id="first_name" title="First Name" />
          <ColumnDefinition id="last_name" title="Last Name" />
          <ColumnDefinition id="title" title="Title" />
          <ColumnDefinition id="group" title="Group" />
          <ColumnDefinition id="email" title="Email" />
          <ColumnDefinition id="id" title=" " customComponent={this.state.toolbar} />
        </RowDefinition>
      </StyledGriddle>

    );
  }
}
TourRosterTable.propTypes = {
  members: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  handleRemoveMember: PropTypes.func.isRequired,
  handleEditMember: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
};
export default TourRosterTable;



// WEBPACK FOOTER //
// src/routes/tours/components/TourRosterTable.js